import { BaseWebComponentView } from '../../../../../framework/BaseWebComponentView';
import { FormGroup } from '../../../../../ui/gzForm/formGroup/form-group';
import { GzAccordionWebComponent } from '../../../../../ui/gzAccordion';
import { GzFormFieldWebComponent } from '../../../../../ui/gzForm/formField';
import { GzChipsGeneratorInputWebComponent } from '../../../../../ui/gzChipsGeneratorInput';
import { CustomizableValidator } from '../../../../../ui/gzForm/validators/customizable.validator';
import { translateFn } from '../../../../../utils/translator.helper';
import { ADDITIONAL_TARGETS_LIMIT, AdditionalTargetsViewData } from '../types';
import { ValidationResult } from '../../../../../ui/gzForm/formField/types/form-validator';
import { GzInfoBoxWebComponent } from '../../../../../ui/gzInfoBox';
import { WEB_COMPONENT_GZ_INFO_BOX } from '../../../../../webcomponents.constants';
import { InfoBoxSeverity } from '../../../../../ui/gzInfoBox/types';
import { toggleVisibility } from '../../../../../utils/htmlElement.utils';

export class InstallAgentAdditionalTargetsFormView extends BaseWebComponentView {
  public formGroup!: FormGroup;
  public dom: {
    $wrapper: HTMLElement;

    $additionalTargetsAccordion: GzAccordionWebComponent;
    $additionalTargetsHostnameIpFormField: GzFormFieldWebComponent<GzChipsGeneratorInputWebComponent>;
    $warningMessage: GzInfoBoxWebComponent;
  };

  getDomElements(): void {
    this.dom = {
      $wrapper: this.shadow.querySelector('#additional-targets-form-wrapper'),

      $additionalTargetsAccordion: this.shadow.querySelector('#additional-targets-section'),
      $additionalTargetsHostnameIpFormField: this.shadow.querySelector('#targets-hostname-ip-form-field'),
      $warningMessage: this.shadow.querySelector(WEB_COMPONENT_GZ_INFO_BOX),
    };

    this.getTranslations();
    this.setTranslatedStrings();
  }

  getTranslations(): void {
    this.commonStrings = this.stringsTranslator.getCommonStrings();
    this.translations = this.stringsTranslator.getSchedulerStrings();
  }

  setTranslatedStrings(): void {
    this.dom.$additionalTargetsAccordion.accordionTitle = translateFn('ADDITIONAL TARGETS');
    this.dom.$additionalTargetsHostnameIpFormField.Input.strings.label = translateFn('Hostname/IP');
    this.dom.$additionalTargetsHostnameIpFormField.Input.strings.placeholder = translateFn('Enter IP');
    this.dom.$additionalTargetsHostnameIpFormField.Input.strings.invalidItemErrorMessage = translateFn(
      'The Hostname/IP addresses provided must be unique and separated by a comma.'
    );
    this.dom.$additionalTargetsHostnameIpFormField.Input.strings.limitReachedErrorMessage = translateFn(
      'You have reached the limit of ' + ADDITIONAL_TARGETS_LIMIT + ' Hostname/IP addresses.'
    );
    this.dom.$warningMessage.innerHTML = translateFn('You must add at least one additional target.');
  }

  buildSuccessView(viewData: AdditionalTargetsViewData): void {
    this.dom.$warningMessage.severity = InfoBoxSeverity.WARNING;
    const hasNoCompanySelected = viewData.hasNoCompanySelected;

    this.handleHasNoCompanySelectedVisibility(hasNoCompanySelected);
    this.createFormGroup();
    this.addValidators(hasNoCompanySelected);
  }

  private handleHasNoCompanySelectedVisibility(hasNoCompanySelected: boolean): void {
    toggleVisibility(this.dom.$warningMessage, hasNoCompanySelected);
    this.dom.$additionalTargetsAccordion.isOpen = hasNoCompanySelected;
  }

  private addValidators(hasNoCompanySelected: boolean): void {
    if (!hasNoCompanySelected) {
      return;
    }
    this.dom.$additionalTargetsHostnameIpFormField.Validators = [
      CustomizableValidator(this.checkRequiredField.bind(this)),
    ];
  }

  private checkRequiredField(value: string[]): ValidationResult {
    if (value.length === 0) {
      toggleVisibility(this.dom.$warningMessage, true);
      return {
        valid: false,
        error: '',
      };
    }

    toggleVisibility(this.dom.$warningMessage, false);
    return {
      valid: true,
    };
  }

  private createFormGroup(): void {
    this.formGroup = FormGroup.build({
      settings: {
        additionalTargets: this.dom.$additionalTargetsHostnameIpFormField,
      },
    });
  }
}
